<template>
    <div
        class="callout"
        :class="calloutClass"
    >
        <div class="callout-title">{{ title }}</div>
        <div class="callout-body">
            <template v-if="Array.isArray(content)">
                <template v-for="(part, idx) in content" :key="idx">
                    <strong v-if="part.bold">{{ part.text }}</strong>
                    <span v-else>{{ part.text }}</span>
                </template>
            </template>
            <ChatInlineCitations
                v-else
                variant="callout"
                :text="String(content || '')"
                :sources="sources"
            />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import ChatInlineCitations from './ChatInlineCitations.vue'

const props = defineProps({
    tone: { type: String, default: 'danger' },
    title: { type: String, default: '' },
    content: { type: [Array, String], default: '' },
    sources: { type: Array, default: () => [] },
})

const calloutClass = computed(() => {
    if (props.tone === 'success') return 'callout--success'
    if (props.tone === 'neutral') return 'callout--neutral'
    return 'callout--danger'
})
</script>

<style scoped>
.callout {
    border-radius: 6px;
    padding: 14px 16px;
    margin: 14px 0 10px;
    font-size: 13px;
    line-height: 1.6;
}

.callout--danger {
    background: #FDECEC;
    border: 1px solid #F5C7C7;
}

.callout--success {
    background: #E8F4EF;
    border: 1px solid #C4E2D5;
}

.callout--neutral {
    background: #FDECEC;
    border: 1px solid #F5C7C7;
}

.callout-title {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 6px;
}

.callout--danger .callout-title {
    color: #E30613;
}

.callout--success .callout-title {
    color: #0F6E56;
}

.callout--neutral .callout-title {
    color: #E30613;
}

.callout-body {
    color: #3D3D38;
}

.callout-body strong {
    font-weight: 600;
}

.callout--danger .callout-body strong {
    color: #E30613;
}

.callout--success .callout-body strong {
    color: #0F6E56;
}
</style>
